import { Component, ElementRef, EventEmitter, Input, model, OnDestroy, OnInit, Output } from '@angular/core';
import { MdbModalConfig } from 'mdb-angular-ui-kit/modal';
import { HomeService } from '../home/home.service';
import { RunningAppModel } from '../interface/running-app-model';
import { Router } from '@angular/router';
import { MdbPopoverDirective } from 'mdb-angular-ui-kit/popover';
import {  Subject } from 'rxjs';
import { DesktopData } from '../header/header.service';

declare var Meteor: any;

@Component({
  selector: 'app-modal',
  template: `<div [minWidth]="100" [minHeight]="100" appResizable></div>`,
  templateUrl: './modal.component.html',
  styleUrl: './modal.component.scss',
  standalone: false
})
export class ModalComponent implements OnInit, OnDestroy {
  popupData = model<any>();
  @Output() closePopup: EventEmitter<any> = new EventEmitter<any>();
  @Input() view: 'header' | 'body' = 'body';


  homeView?: string;
  config!: MdbModalConfig;

  currentRunningApp: RunningAppModel = {};
  proxiedContent: any = null;
  isLoading: boolean = false;
  proxyError: string | null = null;
  destroy$: Subject<any> = new Subject<any>();

  constructor(
    private elementRef: ElementRef,
    private router: Router,
    private homeService: HomeService) { }

  ngOnInit(): void {
    this.elementRef.nativeElement.classList.add('translucent-bg');
    this.popupData().app.squares = DesktopData();
    this.config = this.popupData().config;
    this.homeView = this.config.data?.homeView;

    // If external URL exists and ns proxying, fetch content through proxy
    if (this.config?.data?.url && this.config?.data?.useProxy) {
      this.fetchProxiedContent(this.config.data.url);
    }
  }

  ngAfterViewInit(): void {

  }
  /**
   * Fetch content through the backend proxy
   */
  async fetchProxiedContent(url: string, options?: RequestInit): Promise<void> {
    this.isLoading = true;
    this.proxyError = null;

    try {
      const result = await new Promise<any>((resolve, reject) => {
        Meteor.call('proxyUrl', url, options, (error: any, res: any) => {
          if (error) reject(error);
          else resolve(res);
        });
      });

      if (result.code >= 200 && result.code < 300) {
        this.proxiedContent = result.data;
      } else {
        this.proxyError = result.message || 'Failed to fetch content';
        console.error('Proxy error:', result);
      }
    } catch (error) {
      this.proxyError = error instanceof Error ? error.message : 'Unknown error occurred';
      console.error('Error fetching proxied content:', error);
    } finally {
      this.isLoading = false;
    }
  }

  /**
   * Reload proxied content
   */
  reloadProxiedContent(): void {
    if (this.config.data?.url) {
      this.fetchProxiedContent(this.config.data.url);
    }
  }

  minimizeModal(): void {
    this.homeService.swapMinimizeModal(
      this.config.data?._id as string,
      this.config.data?.homeView as string
    );
  }

  maximizeModal(): void {
    this.currentRunningApp = this.homeService.doMaximizeModal(
      this.config.data?._id as string,
      this.config.data?.homeView as string
    );
  }

  restoreModal(): void {
    this.currentRunningApp = this.homeService.doRestoreModal(
      this.config.data?._id as string,
      this.config.data?.homeView as string
    );
  }

  moveModalToSquare(square: any, popover: MdbPopoverDirective): void {
    this.homeService.updateRunningAppHomeView(this.config.data?.name, square.ref);
    this.router.navigate(['home', square.id]);
    popover.hide();
  }

  closeModal(): void {
    this.closePopup.emit(this.popupData().config?.data?._id);
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }
}
